import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "../../../environments/environment";

export interface EvaluacionEficacia {
  id?: number;
  id_plan_accion: number;
  id_investigacion: number;
  fecha_evaluacion: string;
  evaluador: string;
  reincidencia: number; // 0 = No, 1 = Sí
  fue_eficaz: number; // 0 = No, 1 = Sí
  indicador_utilizado?: string;
  conclusion: string;
  accion_si_no_eficaz?: string;
  estado?: number;
}

@Injectable({ providedIn: "root" })
export class EvaluacionEficaciaService {
  private apiUrl = `${environment.apiUrl}/api/evaluacion-eficacia`;

  constructor(private http: HttpClient) {}

  getByPlanAccionId(idPlanAccion: number | string): Observable<EvaluacionEficacia[]> {
    return this.http
      .get<EvaluacionEficacia[]>(`${this.apiUrl}/plan-accion/${idPlanAccion}`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  getByInvestigacionId(idInvestigacion: number | string): Observable<EvaluacionEficacia[]> {
    return this.http
      .get<EvaluacionEficacia[]>(`${this.apiUrl}/investigacion/${idInvestigacion}`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  create(payload: EvaluacionEficacia): Observable<EvaluacionEficacia> {
    return this.http
      .post<EvaluacionEficacia>(this.apiUrl, payload, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  update(id: number | string, payload: Partial<EvaluacionEficacia>): Observable<EvaluacionEficacia> {
    return this.http
      .put<EvaluacionEficacia>(`${this.apiUrl}/${id}`, payload, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  delete(id: number | string): Observable<any> {
    return this.http
      .delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }
}